import styled, { css } from 'styled-components';
import { Button, Box, Row } from '@intech/web-ui';
import { device } from './../../device';

export const Line = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const HalfColumn = styled.div`
  @media ${device.tablet}{
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media not ${device.tablet}{
    flex: 0 0 100%;
    max-width: 100%;
  }
  padding: 0 15px;
`;

export const TriColumn = styled.div`
  @media ${device.tablet}{
    flex: 0 0 30%;
    max-width: 30%;
  }
  @media not ${device.tablet}{
    flex: 0 0 100%;
    max-width: 100%;
  }
  padding: 0 15px;
`;

export const GrayBox = styled(Box)`
  color: #7c7e80;
`;

export const FormGroup = styled.div`
  padding: 0 5px 0 0;
  margin-bottom: 10px;
  flex: 0 0 100%;
  max-width: 100%;
  width: 100%;
`;

export const TopText = styled.label`
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding: calc(0.375rem + 1px) 15px calc(0.375rem + 1px) 0;
`;

export const BottomText = styled.label`
  font-size: 10pt;
  align-self: center !important;
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
`;

export const WrapRow = styled(Row)`
  flex-wrap: wrap;
`;
